import { selectPlayerProfilePictureName } from "../balancingSelectors/selectBalancingPictures";
import { selectPlayerLevelFromXp } from "../balancingSelectors/selectBalancingXpLevels";
import { selectPlayerInfo } from "./selectPlayerInfo";
export var selectChatInfo = function (state) {
    var _a = state.chatInfo, chatRoom = _a.chatRoom, newMessages = _a.newMessages;
    var allMessages = chatRoom && chatRoom.chatRoomMessages ? chatRoom.chatRoomMessages : [];
    var newSortedMessages = newMessages.sort(function (a, b) { return (a.creationTimestamp || -1) - (b.creationTimestamp || -1); });
    if (newMessages.length) {
        allMessages = allMessages.concat(newSortedMessages);
    }
    return allMessages.map(function (message) {
        var memberLevel = message.xp ? selectPlayerLevelFromXp(message.xp) : 1;
        var isMessageOwn = selectPlayerInfo(state).playerId.equals(message.playerId);
        return {
            isMessageOwn: isMessageOwn,
            playerLevel: memberLevel,
            profileIcon: selectPlayerProfilePictureName(message.profilePictureId || 1),
            proto: message,
        };
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectChatInfo.ts
// module id = 2576
// module chunks = 3